<template>
  <div class="mt-2 mb-2" v-b-tooltip.hover :title="item.id ? '' : 'Please save this task, before adding labels'">
    <button :disabled="!item.id" class="btn btn-block btn-info" id="addLabel">
      <i class="icon-left far fa-tags"></i>
      Label
    </button>

    <b-popover target="addLabel" ref="addLabel" triggers="click blur">
      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center">Add Label</div>
      <hr class="mt-2 mb-2" />
      <input type="text" v-model="filter" class="form-control mb-2 mt-1" placeholder="Filter..." />

      <div class="bi-label-container">
        <div v-for="label in filteredLabels" :key="label.id">
          <div
            class="bi-label mb-2 cursor-pointer"
            :style="{
              'background-color': label.color,
            }"
            @click="addLabel(label.id)"
          >
            <i v-if="label.icon" :class="label.icon" class="mr-1 ml-1"></i>
            {{ label.title }}
          </div>
        </div>

        <div v-if="!filteredLabels.length">
          <div class="bi-label no-available-labels mb-2">No labels available</div>
        </div>
      </div>
    </b-popover>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { IBoardItemDto } from '@/apiclient/apiclient_generated';
  import { LabelModule, LabelStore } from '@/store/label';
  import lodash from 'lodash';

  @Component
  export default class AddLabels extends Vue {
    private labelStore: LabelModule = LabelStore;
    @Prop() item: IBoardItemDto;

    private filter = '';

    get filteredLabels() {
      const labelsFilteredByCategoryAndTitle = lodash.sortBy(this.labelStore.allActiveSelectedLabels, ['category', 'title']);

      const filteredData = labelsFilteredByCategoryAndTitle.filter((item) => {
        return !this.item.labels?.some((_) => _.id === item.id);
      });

      if (!this.filter) {
        return filteredData;
      }

      return filteredData.filter((item) => item.title.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0);
    }

    async addLabel(labelId) {
      await this.labelStore.addLabel({
        boardItemId: this.item.id,
        labelId,
      });

      const popover: any = this.$refs.addLabel;
      if (popover) {
        this.filter = '';
        popover.doClose();
      }
    }
  }
</script>

<style scoped lang="scss">
  .label {
    font-weight: bold;
    font-size: 1rem;
  }

  .bi-label-container {
    max-height: 200px;
    overflow-y: auto;
  }

  .bi-label-container::-webkit-scrollbar {
    width: 8px;
  }

  .bi-label-container::-webkit-scrollbar-track {
    background: #ddd;
    border-radius: 5px;
  }

  .bi-label-container::-webkit-scrollbar-thumb {
    background: #999;
    border: 2px solid #ddd;
    border-radius: 5px;
  }

  .bi-label {
    color: white;
    padding: 3px 5px;
    border-radius: 3px;
    margin-right: 5px;
  }

  .bi-label,
  no-available-labels {
    background-color: #4e667d;
  }
</style>
